var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"addressBox"},[_c('div',{staticClass:"account",staticStyle:{"display":"flex","align-items":"center"}},[_c('img',{staticStyle:{"width":"16px","margin-right":"5px","height":"16px","border-radius":"50%"},attrs:{"src":_vm.netWorkConfig.logoURI,"alt":""}}),_vm._v(" "+_vm._s(_vm.netWorkConfig.NetWorkName)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }